import {API_SERVERLESS, postFetch} from '../../commonApi';
import {ISearchItem} from '../../types';

export function apiCommunicationCentreModalInternalSaveSearch(JSONRequest: ISearchItem): Promise<{
    data: string;
}> {
    return postFetch(`${API_SERVERLESS}/communicationCentreModalInternal/v4/CCMISS/saveSearch`, true, JSONRequest);
}
